import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Button, Col, Form, message, notification, Spin } from "antd";
import { EconnectStepOne } from "./components/econnect/step-one";
import { EconnectStepTwo } from "./components/econnect/step-two";
import EconnectStepThreePartner from "./components/econnect/step-three-partner";
import EconnectStepThreePublic from "./components/econnect/step-three-public";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { AgendesService } from "./services/agendes-service";
import { MasterDataEventService } from "../../api/master-data-event.service";
import { UserEventService } from "../../api/user.service";
import { IresponseAgendes } from "./common/index";
import { CustomerUrlService } from "../../api/customer-url.service";
import { CustomerUrlDto } from "../../types/customer-url.type";
import { ArrowRightOutlined } from "@ant-design/icons";
import { loadAppConfig } from "../../configs/app-config";

type NotificationType = "success" | "info" | "warning" | "error";

export const MainAgendes: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaid, typeregis, customerid } = useParams<{ agendaid: string; typeregis: string; customerid: string }>();
  const [agenda, setAgenda] = useState<IresponseAgendes[]>();
  const navigate = useNavigate();
  const [masterDataEvent, setMasterDataEvent] = useState<{ value: string; label: string }[]>([]);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingNavigate, setLoadingNavigate] = useState<boolean>(false);
  const [stepsLength, setStepsLength] = useState<number>(4);
  const [customerData, setCustomerData] = useState<CustomerUrlDto>({
    id: 0,
    customerName: "",
    customerNumber: "",
    limit: 0,
    agendaId: "",
    createdAt: "",
    updatedAt: "",
  });
  const [form] = Form.useForm();

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    try {
      if (agendaid) {
        const resAgenda = await AgendesService(apiBaseUrl).getAgenda(agendaid);
        const resMasterDataEvent = await MasterDataEventService(apiBaseUrl).getByEventId(agendaid);
        setMasterDataEvent(resMasterDataEvent.dataSource);
        setAgenda(resAgenda);
        if (customerid) {
          const resCountCustomer = await CustomerUrlService(apiBaseUrl).countCustomerId(customerid, agendaid);
          if (resCountCustomer.status === 505) {
            navigate(`/activity-agenda/limit/partners/${agendaid}/${customerid}`);
          }
          const resCustomer: CustomerUrlDto = await CustomerUrlService(apiBaseUrl).getOneCustomerId(customerid, agendaid);
          form.setFieldValue("company", resCustomer.customerName);
          setCustomerData(resCustomer);
        }
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const onSubmitform = () => {
    form.validateFields().then(async (validateValue) => {
      await AgendesService(apiBaseUrl).resgister(agendaid, validateValue);
      onChangeCurrentStep(currentStep + 1);
    });
  };

  const openNotificationWithIcon = (type: NotificationType) => {
    if (type === "success")
      return notification[type]({
        message: "สำเร็จ",
        description: "กรุณานำ QR-Code ที่ได้รับจากอีเมลของท่านมาเพื่อเช็คอินเข้าร่วมงาน",
      });
    if (type === "error")
      return notification[type]({
        message: "ไม่สำเร็จ",
        description: "ขออภัย เนื่องจากอีเมลนี้มีการลงทะเบียนไปแล้ว",
      });
  };

  const onChangeFormStepOne = async () => {};

  const onChangeCurrentStep = (step: number) => {
    setCurrentStep(step);
  };

  const submitFormParthner = async (event: any) => {
    const data = {
      dataSource: {
        fullname: event.fullName,
        position: event.position,
        company: { value: customerid, label: form.getFieldValue("company") },
        businessEmail: event.businessEmail,
        phoneNumber: event.phoneNumber,
        businessType: masterDataEvent.filter((item) => item.value === event.businessType)[0],
        type: typeregis === "partners" ? "B" : typeregis === "vip" ? "V" : "A",
        otherText: event.otherText,
      },
    };
    try {
      if (agendaid) {
        setLoadingNavigate(true);
        const resCreate = await UserEventService(apiBaseUrl).createByEvent(agendaid, data);
        if (resCreate.status === 500) {
          setLoadingNavigate(false);
          message.error(resCreate.message);
        } else if (resCreate.status === 505) {
          navigate(`/activity-agenda/limit/partners/${agendaid}/${customerid}`);
        } else {
          setLoadingNavigate(false);
          navigate(`/activity-agenda/activity-step/${agendaid}/${resCreate.dataSource.ticketNumber}`);
        }
      }
    } catch (err) {}
  };

  const submitFormGeneral = async (event: any) => {
    const dataAttendee =
      event.attendeeType === "student"
        ? {
            institution: event.institution,
            fieldofStudy: event.fieldofStudy,
            otherFieldofStudy: event.otherFieldofStudy,
            purposeofAttendingS: event.purposeofAttendingS,
            otherPurposeofAttendingS: event.otherPurposeofAttendingS,
          }
        : {
            company: { value: "0", label: event.companyName },
            industry: event.industry,
            position: event.position,
            otherIndustry: event.otherIndustry,
            otherPurposeofAttending: event.otherPurposeofAttending,
            purposeofAttending: event.purposeofAttending,
          };
    const data = {
      dataSource: {
        fullname: event.fullName,
        businessEmail: event.businessEmail,
        phoneNumber: event.phoneNumber,
        attendeeType: event.attendeeType,
        type: typeregis === "partners" ? "B" : typeregis === "vip" ? "V" : "A",
        ...dataAttendee,
      },
    };
    try {
      if (agendaid) {
        setLoadingNavigate(true);
        const resCreate = await UserEventService(apiBaseUrl).createByEvent(agendaid, data);
        if (resCreate.status === 500) {
          setLoadingNavigate(false);
          message.error(resCreate.message);
        } else {
          setLoadingNavigate(false);
          message.success("success");
          navigate(`/activity-agenda/activity-step/${agendaid}/${resCreate.dataSource.ticketNumber}`);
        }
      }
    } catch (err) {}
  };

  const steps = [
    {
      key: 0,
      title: "Agendar",
      content: <EconnectStepOne onChangeData={onChangeFormStepOne} />,
    },
    {
      key: 1,
      title: "Consent",
      content: <EconnectStepTwo onChangeCurrentStep={onChangeCurrentStep} currentStep={currentStep} stepsLength={stepsLength} />,
    },
    {
      key: 2,
      title: "Form",
      content:
        typeregis === "partners" ? (
          <EconnectStepThreePartner
            onChangeCurrentStep={onChangeCurrentStep}
            currentStep={currentStep}
            stepsLength={stepsLength}
            form={form}
            masterDataEvent={masterDataEvent}
            submitFormParthner={submitFormParthner}
            customerData={customerData}
          />
        ) : typeregis === "vip" ? (
          <EconnectStepThreePartner
            onChangeCurrentStep={onChangeCurrentStep}
            currentStep={currentStep}
            stepsLength={stepsLength}
            form={form}
            masterDataEvent={masterDataEvent}
            submitFormParthner={submitFormParthner}
            customerData={customerData}
          />
        ) : (
          <EconnectStepThreePublic
            onChangeCurrentStep={onChangeCurrentStep}
            currentStep={currentStep}
            stepsLength={stepsLength}
            form={form}
            submitFormGeneral={submitFormGeneral}
          />
        ),
    },
  ];

  return (
    <>
      <Spin tip="Loading..." spinning={loading}>
        <Spin tip="Loading..." spinning={loadingNavigate}>
          <div className="w-[webkit-fill-available] rounded-[20px]">
            {steps.map(({ title, content }, i) => {
              return (
                <Col hidden={i === currentStep ? false : true} md={24} key={title}>
                  {content}
                </Col>
              );
            })}
            <br></br>
            <Form.Item className="flex justify-center items-center w-full">
              <div className="flex w-full gap-[5px]">
                {/* {currentStep < steps.length - 1 && currentStep === 2 && (
              <div className="w-[300px]">
                <Button type="primary" className="text-white bg-[rgba(10,78,136,1)] w-full rounded-[5px]" size="large" onClick={onSubmitform}>
                  Confirm
                </Button>
              </div>
            )} */}

                {/* {currentStep > 0 && currentStep !== 3 && currentStep === 2 && (
              <div style={{ display: "flex", width: "300px", gap: "10px" }}>
                <Button
                  style={{
                    borderRadius: "5px",
                    width: "100%",
                  }}
                  size="large"
                  onClick={() => onChangeCurrentStep(currentStep - 1)}
                >
                  <ArrowLeftOutlined /> {`Back`}
                </Button>
              </div>
            )} */}

                {/* {currentStep < steps.length - 1 && currentStep !== 0 && currentStep === 1 && (
              <div className="flex w-full gap-[10px]">
                <Button
                  type="primary"
                  className="text-white bg-[rgba(10,78,136,1)] w-full rounded-[5px]"
                  size="large"
                  onClick={() => onChangeCurrentStep(currentStep + 1)}
                >
                  {`Agree & Continue`}
                </Button>
              </div>
            )} */}

                {/* {currentStep < steps.length - 1 && currentStep !== 0 && currentStep === 2 && (
              <div style={{ display: "flex", width: "100%", gap: "10px" }}>
                <Button
                  style={{
                    color: "white",
                    background: "#005EA6",
                    width: "100%",
                    borderRadius: "5px",
                  }}
                  size="large"
                  onClick={onClickNext}
                >
                  {`Next`}
                </Button>
              </div>
            )} */}
                {currentStep < steps.length - 1 && currentStep === 0 && (
                  // <Space>
                  //   <Button
                  //     type="primary"
                  //     className="w-[146.5px] h-[70px] rounded-[10px] p-[12px] px-[16px] bg-[rgba(64,159,216,1)]"
                  //     onClick={() => {
                  //       onChangeCurrentStep(currentStep + 1);
                  //     }}
                  //   >
                  //     <div className="w-[109px] h-[44px]">
                  //       <h2 className=" font-['Open_Sans'] font-bold text-[15px] leading-[22px] tracking-[0%] text-center text-[rgba(255,255,255,1)]">
                  //         General Public
                  //       </h2>
                  //       <span className="font-['Open_Sans'] font-normal text-[12px] leading-[22px] tracking-[0%] text-center text-[rgba(255,255,255,1)]">
                  //         (บุคคลทั่วไป)
                  //       </span>
                  //     </div>
                  //   </Button>
                  //   <Button
                  //     type="primary"
                  //     className="w-[146.5px] h-[70px] rounded-[10px] p-[12px] px-[16px] bg-[rgba(10,78,136,1)]"
                  //     onClick={() => {
                  //       onChangeCurrentStep(currentStep + 1);
                  //     }}
                  //   >
                  //     <div className="w-[109px] h-[44px]">
                  //       <h2 className=" font-['Open_Sans'] font-bold text-[15px] leading-[22px] tracking-[0%] text-center text-[rgba(255,255,255,1)]">
                  //         Clients & Partners
                  //       </h2>
                  //       <span className="font-['Open_Sans'] font-normal text-[12px] leading-[22px] tracking-[0%] text-center text-[rgba(255,255,255,1)]">
                  //         (ลูกค้าและพาร์ทเนอร์)
                  //       </span>
                  //     </div>
                  //   </Button>
                  // </Space>
                  <Button
                    type="primary"
                    className="w-[301px] h-[58px] rounded-full border-2 px-[45px] py-[13px] gap-8 bg-[rgba(10,78,136,1)]"
                    onClick={() => {
                      onChangeCurrentStep(currentStep + 1);
                    }}
                  >
                    <h2 className="font-manrope font-bold text-[20px] leading-[32px] tracking-[0px] text-center text-[rgba(255,255,255,1)]">
                      Register <ArrowRightOutlined />
                    </h2>
                  </Button>
                )}
              </div>
            </Form.Item>
          </div>
        </Spin>
      </Spin>
    </>
  );
};
